'use client';
import type { PropsWithChildren } from 'react';
import MainFooter from './main-footer';
import LunarNewYearHeader from '@/app/[locale]/[city]/components/session/new-year-header/lunar-new-year';
// import StoreHeader from '@/app/[locale]/[city]/components/session/store-header';
import AddressCookieSync from '@/components/address-cookie-sync';
import DesktopHeader from '@/components/desktop-header';
import { useIsMobile } from '@/lib/is-mobile';

/**
 * MainLayout - Modern layout with gradient header and AI integration
 * Replaces the old MainLayout with new design system
 * Desktop: Shows DesktopHeader
 * Mobile: Shows StoreHeader
 */
export default function MainLayout({ children }: PropsWithChildren) {
  const isMobile = useIsMobile();

  return (
    <>
      <AddressCookieSync />
      {isMobile ? <LunarNewYearHeader /> : <DesktopHeader />}
      {children}
      <MainFooter />
    </>
  );
}
